var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint no-param-reassign: 0 */
import moment from 'moment-timezone';
import { Map as ImmutableMap } from 'immutable';

export var VALIDATION_ERROR_REQUIRED_ATTRIBUTE = 'validation.error.required.attribute';
export var VALIDATION_ERROR_NOT_A_NUMBER = 'validation.error.not.a.number';
export var VALIDATION_ERROR_MIN_DATE_RANGE = 'validation.error.min.date.range';
export var VALIDATION_ERROR_EMAIL_NOT_VALID = 'validation.error.email.not.valid';

export function isRequired(value) {
  return (
    // Empty string
    value !== '' &&
    // Not null
    value !== null &&
    // Not undefind
    value !== undefined && (
    // Not an array, or if array it contains at least one item
    !Array.isArray(value) || value.length > 0) && (
    // Not an Immutable List, or if a List contains at least one item
    (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || !Reflect.has(value, 'size') || value.size > 0) ? null : VALIDATION_ERROR_REQUIRED_ATTRIBUTE
  );
}

export function isNumber(value) {
  try {
    var n = parseFloat(value, 10);
    return Number.isNaN(n) ? VALIDATION_ERROR_NOT_A_NUMBER : null;
  } catch (e) {
    return VALIDATION_ERROR_NOT_A_NUMBER;
  }
}

export function isAfterDate(minDate) {
  return function isAfterDateValidator(value) {
    if (moment.isMoment(minDate)) {
      if (moment.isMoment(value)) {
        if (value.isBefore(minDate)) {
          return VALIDATION_ERROR_MIN_DATE_RANGE;
        }
      } else if (value < minDate.unix() * 1000) {
        return VALIDATION_ERROR_MIN_DATE_RANGE;
      }
    } else if (moment.isMoment(value) && value.unix() * 1000 < minDate) {
      return VALIDATION_ERROR_MIN_DATE_RANGE;
    }
    if (value < minDate) {
      return VALIDATION_ERROR_MIN_DATE_RANGE;
    }

    return null;
  };
}

export function isValidEmail(value) {
  var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
  return (
    // Empty string
    value !== '' &&
    // Not null
    value !== null &&
    // Not undefind
    value !== undefined &&
    // Not a valid email
    emailRegex.test(value) ? null : VALIDATION_ERROR_EMAIL_NOT_VALID
  );
}

export function invokeValidator(self, hardValidation, validator, value) {
  if (Array.isArray(validator)) {
    var validations = validator.map(function (v) {
      if (!hardValidation && v === isRequired) {
        return null;
      }
      return v.apply(self, [value, self]);
    }).filter(Boolean);
    return validations[0];
  }
  if (!hardValidation && validator === isRequired) {
    return null;
  }
  return validator.apply(self, [value, self]);
}

export function decorateValidation(Record, spec) {
  Record.validationSpec = spec;
  Record.prototype.setValidationError = function setValidatorError(field, errorMessage) {
    var validationErrors = this.meta.get('validationErrors') || {};
    validationErrors[field] = errorMessage;
    return this.setIn(['meta', 'validationErrors'], validationErrors);
  };

  Record.prototype.isValid = function isValid() {
    var validationErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return Object.keys(validationErrors || this.meta.get('validationErrors') || {}).length === 0;
  };

  /**
   * Validate this record, or a single value
   *
   * @param If no params, performs a soft validation (isRequired is ignored). If param 0 is true, performs a hard validation.
   *        If two or more params, performs a single value validation. Extra validation functions can be added as a third param. Must be an array of functions
   */
  Record.prototype.validate = function validate() {
    var _this = this;

    var validationErrors = {};

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var hardValidation = args[0] === true;
    if (args.length === 2) {
      var key = args[0],
          value = args[1];

      if (Reflect.has(Record.validationSpec, key)) {
        var validators = Record.validationSpec[key];
        validators = Array.isArray(validators) ? validators : [validators].filter(Boolean);
        var localValidators = this.meta.has('localValidators') ? this.meta.getIn(['localValidators', key], []) : [];
        return invokeValidator(this, true, [].concat(_toConsumableArray(validators), _toConsumableArray(localValidators)), value);
      }
      return null;
    }

    Object.keys(Record.validationSpec).forEach(function (key) {
      var validator = Record.validationSpec[key];
      var result = invokeValidator(_this, hardValidation, validator, _this.get(key));
      if (result) {
        validationErrors[key] = result;
      }
    });

    return { valid: this.isValid(validationErrors), validationErrors: validationErrors };
  };

  Record.prototype.validateAndStore = function validateAndStore(hardValidation) {
    var _validate = this.validate(hardValidation),
        validationErrors = _validate.validationErrors;

    return this.setIn(['meta', 'validationErrors'], validationErrors);
  };

  Record.prototype.addLocalValidator = function addLocalValidator(key, validator) {
    var localValidators = this.meta.get('localValidators', new ImmutableMap());
    var keyValidators = localValidators.get(key, []);
    keyValidators.push(validator);
    localValidators = localValidators.set(key, keyValidators);
    return this.setIn(['meta', 'localValidators'], localValidators);
  };

  Record.prototype.clearValidation = function clearValidation() {
    return this.setIn(['meta', 'validationErrors'], {});
  };

  return Record;
}